module.exports = __webpack_public_path__ + "img/CervezaMinervaStour.8884cf75.jpg";